module.exports = __webpack_public_path__ + "media/images/pinterest-white@2x-d8cd83859b102328338920f17dde1f69.png";